import React, { useRef } from "react";
import { Link as RouterLink } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import {
    AppBar,
    Button,
    ClickAwayListener,
    Divider,
    Grow,
    Hidden,
    IconButton,
    Link,
    ListItemIcon,
    MenuItem, MenuList,
    Paper,
    Popper,
    Toolbar,
    Tooltip,
    Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
    AccountCircle,
    ArrowDropDown,
    Settings,
    Edit,
} from '@material-ui/icons';
import BusinessIcon from '@material-ui/icons/Business';
import Badge from '@material-ui/core/Badge';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import HelpIcon from '@material-ui/icons/Help';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import ListIcon from '@material-ui/icons/List';
import OpacityIcon from '@material-ui/icons/Opacity';
import DashboardIcon from '@material-ui/icons/Dashboard';
import SettingsApplicationsIcon from '@material-ui/icons/SettingsApplications';
import logoPulse from './assets/Pulse_Level_Logo_white_v2.png';
import logoPulseMobile from './assets/Pulse_Level_Logo_white_v3.png';
import TankIcon from './assets/TankIcon.js';
import { host } from "../data";
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import DialogContentText from '@material-ui/core/DialogContentText';
import Rating from '@material-ui/lab/Rating';
import Slide from '@material-ui/core/Slide';
import { useTranslation } from 'react-i18next';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const logo = logoPulse;
const logoMobile = logoPulseMobile;

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    grow: {
        flexGrow: 1,
        height: '64px'
    },
    logo: {
        maxHeight: '50px',
        marginRight: theme.spacing(2),
    },
    logoMobile: {
        width: '30vw',
        maxWidth: '145px',
        marginRight: theme.spacing(1) / 2,
    },
    title: {
        marginLeft: theme.spacing(2),
        display: 'none',
        [theme.breakpoints.up('xs')]: {
            display: 'block',
            //maxWidth: 177
        },
    },
    title_small: {
        marginLeft: theme.spacing(2),
        display: 'none',
        [theme.breakpoints.up('xs')]: {
            display: 'block',
            maxWidth: 177
        },
    },
    icon_link: {
        display: 'none',
        [theme.breakpoints.up('xs')]: {
            display: 'block',
        },
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(0),
    },
    devicebutton: {
        marginRight: theme.spacing(2),
    },
    alertIcon: {
        marginRight: theme.spacing(1),
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('xs')]: {
            display: 'flex',
        },
    },
    menuItem: {
        minWidth: '500px',
        marginTop: '5px',
        marginBottom: '5x',
        marginLeft: '0',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    clearAll: {
        marginTop: '5px',
        textAlign: "center",
        color: '#1976d2',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    centeredMenuItem: {
        minWidth: '400px',
        textAlign: "center",
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    clearIcon: {
        float: "right",
        marginLeft: 'auto',
        marginRight: '0',
        width: '10px',
        minWidth: '25px',
    },
    notificationDescription: {
        marginRight: '25px',
    },
    noNotificationsString: {
        marginTop: '10px',
        textAlign: "center",
        minWidth: '400px',
    },
    FeedbackButton: {
        marginRight: '20px',
        color: 'white',
        borderColor: 'white',
    },
    navBox: {
        borderRadius: 8
    },
    HeaderIcon: {
        marginLeft: '5px'
    },
}));

export default function Header({ orgInfo, orgs, orgNavigationHandler }) {
    const classes = useStyles();
    const userFeedback = useRef("");
    const [orgOpen, setOrgOpen] = React.useState(false);
    const [orgAnchor, setOrgAnchor] = React.useState(null);
    const [settingsOpen, setSettingsOpen] = React.useState(false);
    const [settingsAnchor, setSettingsAnchor] = React.useState(null);
    const [openThankYou, setOpenThankYou] = React.useState(false);
    const [feedbackMenuOpen, setFeedbackMenuOpen] = React.useState(false);
    const [feedbackSubjectRadio, setFeedbackSubjectRadio] = React.useState("");
    const [userRating, setUserRating] = React.useState(null);
    const { t, i18n } = useTranslation();

    const handleOrgOpen = (event) => {
        setOrgAnchor(event.currentTarget);
        setOrgOpen(true);
    };

    const handleOrgClose = () => {
        setOrgOpen(false);
    };

    const handleOrgClick = (org) => {
        handleOrgClose();
        orgNavigationHandler(org);
    };

    const handleSettingsOpen = (event) => {
        setSettingsAnchor(event.currentTarget);
        setSettingsOpen(true);
    };

    const handleSettingsClose = () => {
        setSettingsOpen(false);
    };

    const handleSignOut = () => {
        Auth.signOut();
    };

    const handleClickOpen = () => {
        setFeedbackSubjectRadio(null);
        setUserRating(null);
        setFeedbackMenuOpen(true);
    };

    const handleFeedbackClose = () => {
        setFeedbackMenuOpen(false);
    };

    const handleFeedbackSend = async () => {
        if (userFeedback.current.value != "") {
            let user = await Auth.currentAuthenticatedUser();
            user.getSession((err, session) => {
                if (err) {
                    console.log(err);
                    return;
                }

                const sessionToken = session.getIdToken().jwtToken;

                var body = JSON.stringify(
                    {
                        'Subject': feedbackSubjectRadio,
                        'FeedbackText': userFeedback.current.value,
                        'Rating': userRating,
                    }
                );

                var requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': sessionToken
                    },
                    body: body
                };

                fetch(host + '/user/feedback', requestOptions)
                    .then(results => results.json())
                    .then(data => {
                    });
            });

            setFeedbackMenuOpen(false);
            setOpenThankYou(true);
        } else {
            userFeedback.current.focus();
        }
    };

    const handleThankYouClose = () => {
        setOpenThankYou(false);
    };

    return (
        <div className={classes.grow}>
            <AppBar position='static'>
                <Toolbar >
                    <Hidden smDown>
                        <Button
                            component={RouterLink}
                            to={"/"}
                        >
                            <img edge='start'
                                alt='Graco'
                                className={classes.logo}
                                src={logo} />
                        </Button>
                    </Hidden>

                    <Hidden mdUp>
                        <Button
                            component={RouterLink}
                            to={"/"}
                        >
                            <img edge='start'
                                alt='Graco'
                                className={classes.logoMobile}
                                src={logoMobile} />
                        </Button>
                    </Hidden>
                    <Hidden lgUp>
                        <Tooltip title={t("selectOrganization")}>
                            <IconButton aria-controls={orgOpen ? 'org-list-grow' : undefined}
                                edge='start'
                                aria-haspopup='true'
                                color='inherit'
                                onClick={handleOrgOpen}>
                                <Typography className={classes.title_small} variant='h6' noWrap>
                                    {orgInfo.orgName}
                                </Typography>
                                <ArrowDropDown />
                            </IconButton>
                        </Tooltip>
                    </Hidden>
                    <Hidden mdDown>
                        <Tooltip title={t("selectOrganization")}>
                            <IconButton aria-controls={orgOpen ? 'org-list-grow' : undefined}
                                edge='start'
                                aria-haspopup='true'
                                color='inherit'
                                onClick={handleOrgOpen}>
                                <Typography className={classes.title} variant='h6' noWrap>
                                    {orgInfo.orgName}
                                </Typography>
                                <ArrowDropDown />
                            </IconButton>
                        </Tooltip>
                    </Hidden>

                    <Popper open={orgOpen}
                        anchorEl={orgAnchor}
                        placement='bottom-start'
                        transition>

                        {({ TransitionProps, placement }) => (
                            <Grow {...TransitionProps}
                                style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}>
                                <Paper>
                                    <ClickAwayListener onClickAway={handleOrgClose}>
                                        <MenuList autoFocusItem={orgOpen} id='org-list-grow'>
                                            {orgInfo.isOrgEditor && <MenuItem onClick={() => { setOrgOpen(false) }} component={RouterLink} to={{ pathname: '/orgs/new', state: { orgInfo: { orgInfo }, orgEdit: true } }}>
                                                <ListItemIcon style={{ minWidth: '30px' }}>
                                                    <Edit />
                                                </ListItemIcon>
                                                {orgInfo.orgName}
                                            </MenuItem>}
                                            {orgInfo.isOrgEditor && <Divider />}
                                            {orgs !== undefined
                                                ? orgs.map((name, index) =>
                                                    <MenuItem key={index} value={name} onClick={() => handleOrgClick(orgs[index])}>
                                                        {name}
                                                    </MenuItem>)
                                                : null}
                                            <Divider />
                                            <MenuItem component={RouterLink} to='/orgs/new'>
                                                + {t("createNewOrg")}
                                            </MenuItem>
                                            {orgInfo.isOrgEditor && <MenuItem component={RouterLink} to={'/orgs/'.concat(orgInfo.orgName).concat('/branches')}>
                                                + {t("createNewBranch")}
                                            </MenuItem>}
                                        </MenuList>
                                    </ClickAwayListener>
                                </Paper>
                            </Grow>)}
                    </Popper>
                    <div className={classes.grow} />
                    {false && <Hidden mdUp>
                        <Tooltip title={orgInfo.orgName}>
                            <IconButton className={classes.icon_link}
                                aria-controls={orgOpen ? 'org-list-grow' : undefined}
                                edge='start'
                                aria-haspopup='true'
                                color='inherit'
                                onClick={handleOrgOpen}>
                                <BusinessIcon />
                            </IconButton>
                        </Tooltip>
                        <div className={classes.grow} />
                    </Hidden>}

                    {orgInfo.isOrgEditor && <Hidden smDown>
                        <IconButton color='inherit' className={classes.icon_link}
                            component={RouterLink}
                            to={{
                                pathname: '/orgs/' + orgInfo.orgName + '/details',
                                state: {
                                    orgInfo: { orgInfo },
                                    orgEdit: true
                                }
                            }}>
                            <DashboardIcon />
                            <Typography className={classes.HeaderIcon}>
                                {t("dashboard")}
                            </Typography>
                        </IconButton>
                    </Hidden>}
                    {false && orgInfo.isOrgEditor && <Hidden mdUp>
                        <Tooltip title={t("dashboard")}>
                            <IconButton color='inherit' className={classes.icon_link}
                                component={RouterLink}
                                to={{
                                    pathname: '/orgs/' + orgInfo.orgName + '/details',
                                    state: {
                                        orgInfo: { orgInfo },
                                        orgEdit: true
                                    }
                                }}>
                                <DashboardIcon />
                            </IconButton>
                        </Tooltip>
                    </Hidden>}
                    {orgInfo.isOrgEditor && <div className={classes.grow} />}
                    {orgInfo.isOrgEditor && <Hidden smDown>
                        <IconButton
                            component={RouterLink}
                            to={"/orgs/" + orgInfo.orgName + "/billing"}
                            size='small'
                            color='inherit'>
                            <PlaylistAddIcon />
                            <Typography className={classes.HeaderIcon}>
                                {t("devices")}
                            </Typography>
                        </IconButton>
                    </Hidden>}
                    {false && orgInfo.isOrgEditor && <Hidden mdUp>
                        <Tooltip title={t("devices")}>
                            <IconButton
                                component={RouterLink}
                                to={"/orgs/" + orgInfo.orgName + "/billing"}
                                size='small'
                                color='inherit'>
                                <PlaylistAddIcon />
                            </IconButton>
                        </Tooltip>
                    </Hidden>}
                    {orgInfo.isOrgEditor && <div className={classes.grow} />}
                    <Hidden smDown>
                        {<IconButton className={classes.devicebutton}
                            component={RouterLink}
                            to={"/mytanks/"}
                            size='small'
                            color='inherit'>
                            <TankIcon />
                            <Typography className={classes.HeaderIcon}>
                                {t("myTanks")}
                            </Typography>
                        </IconButton>}
                    </Hidden>
                    {false && <Hidden mdUp>
                        <Tooltip title={t("myTanks")}>
                            {<IconButton className={classes.devicebutton}
                                component={RouterLink}
                                to={"/mytanks/"}
                                size='small'
                                color='inherit'>
                                <TankIcon />
                            </IconButton>}
                        </Tooltip>
                    </Hidden>}

                    <div className={classes.grow} />
                    <Hidden smDown>
                        <Tooltip title={t("sendUsFeedback")}>
                            <Button className={classes.FeedbackButton} variant="outlined" onClick={handleClickOpen}>
                                {t("sendUsFeedback")}
                            </Button>
                        </Tooltip>
                    </Hidden>

                    <Dialog open={feedbackMenuOpen} onClose={handleFeedbackClose} aria-labelledby="form-dialog-title">
                        <DialogTitle id="form-dialog-title">{t("sendUsFeedback")}</DialogTitle>
                        <DialogContent>

                            <DialogContentText >
                                {t("feedbackStr1")}
                            </DialogContentText>

                            <Rating
                                defaultValue={0}
                                precision={0.5}
                                size="large"
                                style={{ marginBottom: '20px' }}
                                onChange={e => setUserRating(e.target.value)}
                            />

                            <DialogContentText>
                                {t("feedbackStr2")}
                            </DialogContentText>

                            <RadioGroup
                                style={{ marginBottom: '20px' }}
                                value={feedbackSubjectRadio}
                                onChange={e => setFeedbackSubjectRadio(e.target.value)}
                            >
                                <FormControlLabel value="devices" control={<Radio />} label={t("setup")} />
                                <FormControlLabel value="charting" control={<Radio />} label={t("mapping")} />
                                <FormControlLabel value="data" control={<Radio />} label={t("dataVisualization")} />
                                <FormControlLabel value="analysis" control={<Radio />} label={t("dataAnalysis")} />
                                <FormControlLabel value="reporting" control={<Radio />} label={t("reports")} />
                                <FormControlLabel value="other" control={<Radio />} label={t("other")} />
                            </RadioGroup>

                            <DialogContentText>
                                {t("feedbackStr3")}
                            </DialogContentText>

                            <TextField
                                fullWidth
                                multiline
                                rows={4}
                                // autoFocus
                                variant="filled"
                                inputRef={userFeedback}
                                inputProps={{ maxLength: 250 }}
                            />

                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleFeedbackClose} color="primary">
                                {t("cancel")}
                            </Button>
                            <Button onClick={handleFeedbackSend} color="secondary">
                                {t("send")}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={openThankYou}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={handleThankYouClose}
                    >
                        <DialogTitle>{t("thankYou")}</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                {t("feedbackStr4")}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleThankYouClose} color="secondary">
                                {t("close")}
                            </Button>
                        </DialogActions>
                    </Dialog>


                    <Tooltip title={t("settings")}>
                        <IconButton edge='end'
                            aria-controls={settingsOpen ? 'settings-list-grow' : undefined}
                            ria-haspopup='true'
                            onClick={handleSettingsOpen}
                            color='inherit'>
                            <Settings />
                        </IconButton>
                    </Tooltip>

                    <Popper open={settingsOpen}
                        anchorEl={settingsAnchor}
                        placement='bottom-end'
                        transition>
                        {({ TransitionProps, placement }) => (
                            <Grow {...TransitionProps}
                                style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}>
                                <Paper>
                                    <ClickAwayListener onClickAway={handleSettingsClose}>
                                        <MenuList autoFocusItem={settingsOpen} id='settings-list-grow'>
                                            <Hidden mdUp>
                                                {orgInfo.isOrgEditor && <MenuItem component={RouterLink}
                                                    to={{
                                                        pathname: '/orgs/' + orgInfo.orgName + '/details',
                                                        state: {
                                                            orgInfo: { orgInfo },
                                                            orgEdit: true
                                                        }
                                                    }} onClick={handleSettingsClose}>
                                                    <ListItemIcon>
                                                        <DashboardIcon />
                                                    </ListItemIcon>
                                                    {t("dashboard")}
                                                </MenuItem>}
                                                <MenuItem component={RouterLink} to={'/mytanks/'} onClick={handleSettingsClose}>
                                                    <ListItemIcon>
                                                        <TankIcon />
                                                    </ListItemIcon>
                                                    {t("myTanks")}
                                                </MenuItem>
                                                <Divider />
                                            </Hidden>
                                            {false
                                                ? <MenuItem component={RouterLink} to={'/orgs/'.concat(orgInfo.orgName)} onClick={handleSettingsClose}>
                                                    <ListItemIcon>
                                                        <SettingsApplicationsIcon />
                                                    </ListItemIcon>
                                                    {t("settings")}
                                                </MenuItem>
                                                : null}
                                            <MenuItem component={RouterLink} to='/profile' onClick={handleSettingsClose}>
                                                <ListItemIcon>
                                                    <AccountCircle fontSize="small" />
                                                </ListItemIcon>
                                                {t("userSettings")}
                                            </MenuItem>
                                            <Divider />
                                            {orgInfo.isOrgEditor
                                                ? <MenuItem component={RouterLink} to={'/orgs/'.concat(orgInfo.orgName).concat('/Manage')} onClick={handleSettingsClose}>
                                                    <ListItemIcon>
                                                        <AccountTreeIcon fontSize="small" />
                                                    </ListItemIcon>
                                                    {t("permissionManagement")}
                                                </MenuItem>
                                                : null}
                                            {orgInfo.isOrgEditor
                                                ? <MenuItem component={RouterLink} to={'/orgs/'.concat(orgInfo.orgName).concat('/Billing')} onClick={handleSettingsClose}>
                                                    <ListItemIcon>
                                                        <ListIcon fontSize="small" />
                                                    </ListItemIcon>
                                                    {t("deviceBilling")}
                                                </MenuItem>
                                                : null}
                                            {orgInfo.isOrgEditor
                                                ? <MenuItem component={RouterLink} to={'/orgs/'.concat(orgInfo.orgName).concat('/templates')} onClick={handleSettingsClose}>
                                                    <ListItemIcon>
                                                        <TankIcon fontSize="small" />
                                                    </ListItemIcon>
                                                    {t("templates")}
                                                </MenuItem>
                                                : null}
                                            {orgInfo.isOrgEditor
                                                ? <MenuItem component={RouterLink} to={'/orgs/'.concat(orgInfo.orgName).concat('/Fluids')} onClick={handleSettingsClose}>
                                                    <ListItemIcon>
                                                        <OpacityIcon fontSize="small" />
                                                    </ListItemIcon>
                                                    {t("fluids")}
                                                </MenuItem>
                                                : null}

                                            <MenuItem component={RouterLink} to='/help' onClick={handleSettingsClose}>
                                                <ListItemIcon>
                                                    <HelpIcon fontSize="small" />
                                                </ListItemIcon>
                                                {t("help")}
                                            </MenuItem>
                                            <Divider />
                                            <MenuItem component={Link} href='/' onClick={handleSignOut}>
                                                <ListItemIcon>
                                                    <ExitToAppIcon fontSize="small" />
                                                </ListItemIcon>
                                                {t("logOut")}
                                            </MenuItem>
                                        </MenuList>
                                    </ClickAwayListener>
                                </Paper>
                            </Grow>)}
                    </Popper>
                </Toolbar>
            </AppBar>
        </div>
    );
}
